var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"owal-storage__container"},[_c('owal-panel',{staticClass:"owal-storage__panel",attrs:{"title":"Diagnostic Export","bottom-buttons":[
      {
        title: 'Export Local Data',
        identifier: 'save'
      },
      {
        title: 'Logout & Reload Application',
        identifier: 'clear'
      }
    ]},on:{"button-click":_vm.handleButton}},[_vm._v("\n    Use the buttons below to export a diagnostic file to your browser's downloads folder.\n    ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }